import { defineMessages, type MessageValue } from 'react-intl';

export const menuCategoriesGridProductCardLinkMessages = defineMessages<{
  readonly a11yLabel: { readonly product_name: MessageValue };
}>({
  a11yLabel: {
    defaultMessage: 'Navigate to "{product_name}" customization screen',
    description: 'Menu | Categories grid | Product | Link a11y label',
  },
});
